import { OwnProps } from '~/types/ownProps';
import { RouteStep } from '~/routes/calculations/types';

const step: RouteStep = {
  route: '/homeowners-insurance/quotes/property-basics-v2',
  isAccessible: ({ application: { hasHome } }: OwnProps): boolean => hasHome,
  breadcrumbStep: 'property',
};

export default step;
